module.exports = __webpack_public_path__ + "img/League_07.5414ac66.png";